module.exports = __webpack_public_path__ + "img/2025-04-12c_1.6b26595e.jpg";